import React from "react";
import "../Modules/valueprop.css";
import Contact from "./Contact";
import Navbar from "./Navbar";



const About = () => {

  return (
    <>
    <div className="bg-dark fixed-top">
    <Navbar/>
    </div> <br />
      <center>        
        <section className="aboutSection" > <br />
        <h2 className='ourMissionHeading' style={{color: 'white',marginTop:'5px',marginBottom:'5px'}}>About Us</h2>
        <div className="container-fluid">
            <div className='innerOurMissionSection'>
                  <h2 className='ourMissionHeading'>Our Mission</h2> <br />
                  <div className="mainBlueColor wow animate__animated animate__zoomIn"  style={{textAlign:'justify'}}>
                  Our mission is clear and impactful: to deliver high-quality, affordable food that meets
                  the health and nutritional needs of Nigerians, wherever they are in the world.
                    </div> <br /> 
                    <h2 className='ourMissionHeading greenText'>Our Vision</h2> <br />
                    <div className="mainBlueColor wow animate__animated animate__zoomIn"  style={{textAlign:'justify'}}>
                                              Driven by our vision to build a digital marketplace inspired by the vibrant essence of
                          African open food markets, we aim to connect people across the globe with authentic, culturally
                          tailored food options. Our platform will blend tradition with modern convenience, offering an
                          immersive and personalized shopping experience that celebrates the diversity and richness of
                          African cuisine. By bringing the spirit of local markets online, we empower individuals to access
                          the tastes of home, no matter where they are.
                    </div> <br />
                    <h2 className='ourMissionHeading'>Inception and Purpose</h2> <br />
                  <div className=" wow animate__animated animate__zoomIn" style={{textAlign:'justify'}}>
                  Food Supply Vision was born out of a desire to reshape the food supply chain, making fresh,
                  high-quality farm produce accessible, convenient, and affordable for all. As cities grow and
                  urbanization advances, people are increasingly distanced from the sources of their food. The
                  founders of Food Supply Vision saw an opportunity to bridge this gap by creating a business
                  model that not only serves consumers with fresh produce but also addresses the underlying
                  infrastructure challenges faced by farmers, vendors, and transporters in the food supply industry.

                  Food Supply Vision operates through three synergistic branches, each addressing a critical stage
                  in the food supply chain. Together, these branches form a seamless ecosystem that cultivates,
                  sells, and transports farm produce, ensuring that consumers enjoy quality food while reducing
                  inefficiencies in the system.
                    </div> <br /> <br />
                  <div >
                    
                  </div> <br />
            </div>
          </div>
        </section>

        <section className='gainSection' style={{backgroundColor:'rgb(25, 25, 25)'}}>
          <div className="container-fluid">
            <div className='innerOurMissionSection'>
                  <h2 className='ourMissionHeading wow animate__animated animate__zoomIn lemonText'>Vertical Integration Advantage</h2><br />
                  <div className="mainBlueColor  wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li> <b> Ownership of Source:</b> By owning the source through GreenGrow, we ensure consistent quality and freshness of produce.</li>
                      <li> <b>Enhanced Stock and Distribution:</b> FreshFlow guarantees efficient logistics, reducing wastage and ensuring timely delivery.</li>
                      <li><b>Optimized Sales and Marketing:</b> Ojaami leverages cutting-edge technology to optimize the shopping experience, making it seamless and user-friendly.
                      </li>
                    </ul>
                    </div> <br />
                   <br />

                   <h2 className='ourMissionHeading wow animate__animated animate__zoomIn greenText'>Cost-Effective and Efficient</h2> <br />
                  <div className="mainBlueColor  wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li><b>Competitive Pricing:</b> Our integrated model allows us to offer products at a cheaper rate than traditional open markets</li>
                      <li><b>Time-Saving:</b> Customers enjoy the convenience of shopping from home without the hassle of visiting crowded markets.</li>
                      <li><b>Comfort and Ease:</b> Our streamlined processes ensure a smooth and enjoyable shopping experience.
                      </li>
                    </ul>
                    </div> <br />
                   <br />
                   

                   <h2 className='ourMissionHeading wow animate__animated animate__zoomIn lemonText'>Target Market Focus</h2> <br />
                  <div className="mainBlueColor  wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li><b>Middle and Low-Class Customers:</b> We cater specifically to those who frequent open markets, providing them with a better alternative.</li>
                      <li><b>Mini-Open Market with Advanced Technology:</b> FSV combines the familiarity of a traditional market with the efficiency of modern technology.</li>
                      
                    </ul>
                    </div> <br />
                   <br />

                   <h2 className='ourMissionHeading wow animate__animated animate__zoomIn greenText'>Data-Driven Approach</h2> <br/>
                  <div className="mainBlueColor  wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li><b>Leading Custodian of Market Data:</b> We are dedicated to becoming the primary source of data and information about informal food markets in Africa.</li>
                      <li><b>Continuous Improvement:</b> Our commitment to continuous improvement sets us apart, as we strive to solve challenges and enhance processes in the African open food markets.</li>
                      
                    </ul>
                    </div> <br />
                   <br />

                   <h2 className='ourMissionHeading wow animate__animated animate__zoomIn lemonText'>Innovative Sourcing</h2> <br />
                  <div className="mainBlueColor  wow animate__animated animate__zoomIn leftTextAlign">
                    <ul>
                      <li><b>Retail Virtual Reality Gaming System:</b> We aim to break the boundaries of traditional shopping by developing an immersive virtual reality shopping experience.</li>
                      <li><b>Influence in Sourcing, Inventory, and Mobility:</b> Our comprehensive approach ensures we exert significant influence in managing all aspects of the supply chain.</li>
                      
                    </ul>
                    </div> <br />
                   <br />
            </div>
          </div>
        </section>

      </center>
      <div >
       <Contact/>
      </div>
      
    </>
  );
};

export default About;
